const dictionary = {
  "news": { en: 'news', es: 'noticias', ca: 'notícies' },
  "subsection": { en: 'sub section', es: 'sub sección', ca: 'sub secció' },
  "los-angeles": { en: 'los angeles' },
  "primavera-pro": { en: 'primavera pro' },
  "relive-primavera": { en: 'relive primavera' },
}

export default dictionary;